import React from 'react'

function WhatAreSnapVideo() {
  return (
    <section className="fifty-what-are-snap-video" id="fifty-what-are-snap-video">
        <div className="row ">
            <div className="container">
                <div className="what-are-snap-video-wrap wow zoomIn">
                    <div className="top-content">
                        <div className="title">
                            <h2>One Video. <span className="red">Every Platform. Every Month.</span></h2>
                        </div>
                        <p>Snapshot Videos turn your newsletter or talking points into a 90-second, polished
                            video—perfect for email, social media, and your website.</p>
                    </div>
                    <div className="fifty-popup-content">
                        <div className="popup-wrap">
                            <div className="popup-box wow fadeInLeft">
                                <div className="popup-image">
                                    <img src="/images/firstFifty-images/required-icon.png" alt="No Filming Required" />
                                </div>
                                <div className="popup-text">
                                    <h3>No Filming Required</h3>
                                </div>
                            </div>
                            <div className="popup-box wow zoomIn">
                                <div className="popup-image">
                                    <img src="/images/firstFifty-images/scripts-icon.png" alt="No Scripts To Write" />
                                </div>
                                <div className="popup-text">
                                    <h3>No Scripts To Write</h3>
                                </div>
                            </div>
                            <div className="popup-box wow fadeInRight">
                                <div className="popup-image">
                                    <img src="/images/firstFifty-images/updates-icon.png"
                                        alt="Just Send Your Updates—we’ll Handle The Rest" />
                                </div>
                                <div className="popup-text">
                                    {/* <h3>Just Send Your Updates <br /> —we’ll Handle The Rest</h3> */}
                                    <h3>Send Your Newsletter We'll Handle the Rest</h3>
                                </div>
                            </div>
                        </div>
                        <h3>It’s member communication made easy.</h3>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default WhatAreSnapVideo